import React from "react";
import { Link } from "react-router-dom";

/**
 * Formats text content to highlight @mentions with blue bold styling
 * 
 * @param {string} content - The text content to format
 * @returns {React.ReactNode[]} - Array of text and mention elements
 * 
 * Usage:
 *   <p>{formatMentions("Hey @John Doe check this out!")}</p>
 *   // Renders: "Hey " + <Link to="/profile/john-doe">@John Doe</Link> + " check this out!"
 */
export const formatMentions = (content) => {
  if (!content || typeof content !== "string") return content;

  // Regex to match @mentions (@ followed by 1-3 capitalized words)
  // Matches: @Name, @First Last, @First Middle Last
  // Stops at lowercase words to avoid capturing sentence text like "@John see this"
  const mentionRegex = /@([A-Z][a-zA-Z]*(?:\s+[A-Z][a-zA-Z]*){0,2})/g;
  
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = mentionRegex.exec(content)) !== null) {
    // Add text before the mention
    if (match.index > lastIndex) {
      parts.push(content.substring(lastIndex, match.index));
    }

    // Add the mention as a styled span
    const mentionName = match[1];
    parts.push(
      <span key={match.index} className="mention-highlight">
        @{mentionName}
      </span>
    );

    lastIndex = match.index + match[0].length;
  }

  // Add remaining text after last mention
  if (lastIndex < content.length) {
    parts.push(content.substring(lastIndex));
  }

  return parts.length > 0 ? parts : content;
};

export default formatMentions;
